import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory, {
  PaginationProvider,
  SizePerPageDropdownStandalone,
  PaginationListStandalone,
} from 'react-bootstrap-table2-paginator'
import cellEditFactory from 'react-bootstrap-table2-editor'
import { CSVExport } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min'
import filterFactory, { selectFilter, textFilter } from 'react-bootstrap-table2-filter'
import { DropDownEditor } from './DropDownEditor'
import { ExcludedEditor } from './ExcludedEditor'
import { handleUpdateAccountStatus, handleExcludeAccountStatus } from '../../actions/companyActions'
import LoadingSpinner from '../../Shared/LoadingSpinner'
import { Alert, Button, Modal, ModalHeader, ModalBody, ModalFooter, Col, FormGroup, Input, Progress, Label, Badge } from 'reactstrap'
import ExclusionCell from './ExclusionCell'
import ExcludedCell from './ExcludedCell'
import StatusCell from './StatusCell'
import StatusCellNoEdit from './StatusCellNoEdit'
import MailboxTypeCellNoEdit from './MailboxTypeCellNoEdit'
import ExclusionCellNoEdit from './ExclusionCellNoEdit'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css'
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css'
import './navoverrides.css'
import './CompanyUsersTable.css'
import { authProvider } from '../../../services/authProvider'
import { AzureAD } from 'react-aad-msal'
import styled from 'styled-components'

const { ExportCSVButton } = CSVExport

let StyledLabel = styled(Label)`
  font-weight: 500;
`


function useForceUpdate() {
  const [value, setValue] = useState(0) // integer state
  return () => setValue((value) => ++value) // update the state to force render
}

const resetModalOptions = () => {
  return {
    invoiceStatus: 0,
    ignoredUntil: null,
    invoiceReason: '',
    selectedExcludedAdditions: [], // TODO: maybe array?
    excludeReason: '',
    excluded: false
  };
}
let modalSelectedUsers = [];
let modalOptions = resetModalOptions(); // TODO: rename

const CompanyUsersTable = (props) => {
  let [ hasDismissed, setHasDismissed] = useState(false);
  let [ showUpdateRowsModal, setShowUpdateRowsModal] = useState(false);
  let [ showExclusionUpdateModal, setShowExclusionUpdateModal] = useState(false);
  let [ selectedRowCount, updateSelectedRowCount ] = useState(0);
  let [ selectedRowCountCalcRequired, setSelectedRowCountCalcRequired ] = useState(false);
  let [ modalSaving, setModalSaving ] = useState(false);
  let [ modalProgress, setModalProgress ] = useState(0);
  let [ excludeModalReason, setExcludeModalReason ] = useState("") // If just using the modalOptions.excludeReason directly, state doesn't update
  let tableRef;

  let enabledFilter = null

  useEffect(() => {
    // this runs on initial component mount in the dom, checks if this is set in local storage, only show it if we have
    // not dismissed it before on this browser
    const localHasDismissed = localStorage.getItem('hasDismissed')
    setHasDismissed(localHasDismissed)
  }, [])

  const [errorMessage, setErrorMessage] = useState(null)
  const forceUpdate = useForceUpdate()

  const handleDismissed = () => {
    setHasDismissed(true)
    localStorage.setItem('hasDismissed', true)
  }

  const selectFilterOptions = [
    { label: 'Active', value: 0 },
    { label: 'Inactive', value: 1 },
    { label: 'Ignored', value: 2 },
  ]

  const ExcludeAgreementFilterOptions = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ]

  const selectOptions = [
    { label: 'Active', value: 0 },
    { label: 'Ignored', value: 2 },
  ]

  const selectEnabledOptions = [
    { value: true, label: 'Enabled' },
    { value: false, label: 'Disabled' },
  ]

  const selectMailboxTypeOptions = [
    { value: 0,   label: "None" },
    { value: 1,   label: "User" },
    { value: 2,   label: "Shared" },
    { value: 3,   label: "Room" },
    { value: 4,   label: "Equipment" },
    { value: 99,  label: "NoData" },
    { value: 100, label: "Unknown" }
  ]

  const csvMailboxType = {
    0:   "Unknown",
    1:   "User",
    2:   "Shared",
    3:   "Room",
    4:   "Equipment",
    99:  "NoData",
    100: "Unknown",
  }

  const csvInvoiceStatus = {
    0: 'Active',
    1: 'Inactive',
    2: 'Ignored',
  }

  const csvAccountStatus = {
    true: 'Enabled',
    false: 'Disabled',
  }

  //let excludedOptions = props.selectedCompanyExcludedAdditions

  const statusFormatter = (cell, row, rowIndex, formatExtraData) => {
    return <StatusCell cell={cell} row={row} rowIndex={rowIndex} formatExtraData={formatExtraData} />
  }
  
  const statusFormatterNoEdit = (cell, row, rowIndex, formatExtraData) => {
    return <StatusCellNoEdit cell={cell} row={row} rowIndex={rowIndex} formatExtraData={formatExtraData} />
  }

  const mailboxTypeFormatter = (cell, row, rowIndex, formatExtraData) => {
    // TODO: Colourise?
    return <MailboxTypeCellNoEdit cell={cell} row={row} rowIndex={rowIndex} formatExtraData={formatExtraData} />
  }
  
  const exclusionFormatter = (cell, row, rowIndex, formatExtraData) => {
    return row.excludedFromAgreement ? 
      (
        <span id={`exclusionToolTip${rowIndex}`}>Excluded</span>
      ) :
      (
        <ExclusionCell cell={cell} row={row} rowIndex={rowIndex} formatExtraData={formatExtraData} />
      )
  }

  const exclusionFormatterNoEdit = (cell, row, rowIndex, formatExtraData) => {
      return row.excludedFromAgreement ? 
      (
        <span id={`exclusionToolTip${rowIndex}`}>Excluded</span>
      ) :
      (
        <span id={`additionToolTip${rowIndex}`}>
              {row.selectedExcludedAdditions && row.selectedExcludedAdditions.length ? (
                <b>{row.selectedExcludedAdditions.length}</b>
              ) : (
                0
              )}{' '}
              additions
         </span>
      )
  }

  // const filterByExclusionAddition = (filterVal, data) => {
  //   if (filterVal === null || filterVal === undefined || filterVal === '') {
  //     return data
  //   }
  //   var exclusionUsers = data.filter((u) => u.selectedExcludedAdditions !== null)
  //   return exclusionUsers.filter((user) => user.selectedExcludedAdditions.some((s) => s.value === filterVal))
  // }

  const handleExclusionEditClicked = (row) => {
      modalSelectedUsers = row; // Only one modal at a time, so, we'll just re-use the bulk update users modal :)
      modalOptions = resetModalOptions();
      setExcludeModalReason('');
      setShowExclusionUpdateModal(true);
  }

  const hideShowExclusionUpdateModal = () => setShowExclusionUpdateModal(false);

  const excludeAgreementFormatter = (cell, row, rowIndex, formatExtraData) => {
    // If we are including, there is no reason to specify, so, the ExcludedEditor from the editedRenderer will take over, otherwise the onClick hander will open the modal
    return <>
      {row.excludedFromAgreement ? (
        <span id={`exclusionToolTip${rowIndex}`} style={{ color: 'rgba(220, 53, 69)' }}>
          <b>Yes</b>
        </span>
      ) :
      (
        <span id={`exclusionToolTip${rowIndex}`}>No</span>
      )}

     <ExcludedCell onEditClicked={!row.excludedFromAgreement ? handleExclusionEditClicked : null} cell={cell} row={row} rowIndex={rowIndex} />
    </>
  }

  const enabledFormatter = (cell, row, rowIndex, formatExtraData) => {
    if (cell === true) {
      if (row.invoiceStatus && row.invoiceStatus === 2) {
        return <span style={{ color: 'rgba(220, 53, 69, 0.65)' }}>Enabled</span>
      } else if (row.invoiceStatus && row.invoiceStatus === 1) {
        return <span style={{ color: 'rgba(220, 53, 69)' }}>Enabled</span>
      } else {
        return <span>Enabled</span>
      }
    } else if (cell === false) {
      if (row.invoiceStatus && row.invoiceStatus === 2) {
        return <span style={{ color: 'rgba(220, 53, 69, 0.65)' }}>Disabled</span>
      } else if (row.invoiceStatus && row.invoiceStatus === 1) {
        return <span style={{ color: 'rgba(220, 53, 69)' }}>Disabled</span>
      } else {
        return <span>Disabled</span>
      }
    }
  }
  const textFieldFormatter = (cell, row, rowIndex, formatExtraData) => {
    if (row.invoiceStatus && row.invoiceStatus === 2) {
      return <span style={{ wordBreak: 'break-all', color: 'rgba(220, 53, 69, 0.65)' }}>{cell}</span>
    } else if (row.invoiceStatus && row.invoiceStatus === 1) {
      return <span style={{ wordBreak: 'break-all', color: 'rgba(220, 53, 69)' }}>{cell}</span>
    } else {
      return <span style={{ wordBreak: 'break-all' }}>{cell}</span>
    }
  }

  const additionExclusionCsvFormatter = (cell, row, rowIndex) => {
    if (row.selectedExcludedAdditions === null || row.selectedExcludedAdditions === undefined) {
      return 'None'
    }
    if (row.selectedExcludedAdditions.length === 0) {
      return 'None'
    } else {
      return row.selectedExcludedAdditions.map((s) => s.label).join('; ')
    }
  }

  const handleTableChange = (type, rest) => {
    if (type === 'pagination') {
      props.updatePage(rest.page, rest.sizePerPage, rest.sortField, rest.sortOrder, rest.filters)
    } else if (type === 'filter') {
      props.updatePage(rest.page, rest.sizePerPage, rest.sortField, rest.sortOrder, rest.filters)
    } else if (type === 'sort') {
      props.updatePage(rest.page, rest.sizePerPage, rest.sortField, rest.sortOrder, rest.filters)
    } else if (type === 'cellEdit') {
      const { cellEdit } = rest
      const { newValue, rowId, dataField } = cellEdit

      if (dataField === 'invoiceStatus') {
        if (newValue && newValue.selectedOption !== '' && newValue.close !== true) {
          try {
            props.handleUpdateAccountStatus(newValue, rowId, props.selectedCompany.id)
          } catch (err) {
            setErrorMessage('Error Saving, try again later.')
            forceUpdate()
          }
        } else if (newValue.close !== true) {
          setErrorMessage('A Reason is Required')
        } else {
          setErrorMessage(null)
        }
      } else if (dataField === 'additionExclusion' || dataField === 'excludedFromAgreement') {
        if (newValue && newValue.selectedOption !== '' && newValue.close !== true) {
          try {
            props.handleExcludeAccountStatus(newValue, rowId, props.selectedCompany.id)
          } catch (err) {
            setErrorMessage('Error Saving, try again later.')
            forceUpdate()
          }
        } else if (newValue.close !== true) {
          setErrorMessage('A Reason is Required')
        } else {
          setErrorMessage(null)
        }
      }
    }
  }

  const handleBulkRowUpdateModalOpen = (selectedRows) =>{
    console.log(selectedRows);
    modalSelectedUsers = selectedRows;
    modalOptions = resetModalOptions();
    setShowUpdateRowsModal(true);
  }

  const handleBulkRowUpdateModalSubmit = async (userIds) => {
    setModalSaving(true);
    setModalProgress(0);
    console.log(userIds);
    console.log(modalOptions);
    console.log(props);
    let total = userIds.length * 2;
    for(let i = 0; i < userIds.length; i++){
      let userId = userIds[i];

      setModalProgress(i * 2 / total * 100);

      await props.handleUpdateAccountStatus(  
        {
          selectedValue: {
            label: csvInvoiceStatus[modalOptions.invoiceStatus],
            value: modalOptions.invoiceStatus
          },
          selectedOption: modalOptions.invoiceReason
        },
        userId,
        props.selectedCompany.id
      );

      setModalProgress((i * 2 + 1) / total * 100);

      await props.handleExcludeAccountStatus(
        {
          selectedValue: modalOptions.selectedExcludedAdditions,
          selectedOption: modalOptions.excludeReason,
          excluded: modalOptions.excluded
        },
        userId,
        props.selectedCompany.id
      );
    }
    setModalProgress(100);
    setTimeout(() => {
      setModalSaving(false);
      hideShowUpdateRowsModal();
    }, 750)
  };

    const handleExcludeModalSubmit = async (options) => {
        setModalSaving(true);
        setModalProgress(0);
        console.log(modalSelectedUsers);
        console.log(options);
        let userId = modalSelectedUsers.id;

        await props.handleExcludeAccountStatus(
            {
                selectedValue: options.selectedExcludedAdditions,
                selectedOption: options.excludeReason,
                selectedDate: undefined,
                excluded: !modalSelectedUsers.excludedFromAgreement // We're flipping this value from the original value
            },
            userId,
            props.selectedCompany.id
        );
        
        setModalProgress(100);
        setTimeout(() => {
            setModalSaving(false);
            hideShowExclusionUpdateModal();
        }, 750)
    };

  const modalBackDrop = (e) => {
    let { value } = e.target;
    if (value !== 'static') {
      value = JSON.parse(value);
    }
    setBackdrop(value);
  };

  const hideShowUpdateRowsModal = () => setShowUpdateRowsModal(false);

  const calcSelectedRowCount = () => {
    updateSelectedRowCount(tableRef?.selectionContext.selected.length ?? 0);
    setSelectedRowCountCalcRequired(false);
  }

  const columnsEditor = [
    {
      dataField: 'id',
      text: 'Id',
      hidden: true,
      editable: false,
      csvExport: false,
    },
    {
      dataField: 'displayName',
      text: 'Name',
      sort: true,
      headerStyle: (column, colIndex) => {
        return { width: '175px' }
      },
      filter: textFilter({
        placeholder: 'Filter Name...',
      }),
      formatter: textFieldFormatter,
      editable: false,
    },
    {
      dataField: 'userPrincipalName',
      text: 'UPN',
      formatter: textFieldFormatter,
      headerStyle: (column, colIndex) => {
        return { width: '275px' }
      },
      sort: true,
      filter: textFilter({
        placeholder: 'Filter Email...',
      }),
      editable: false,
    },
    {
      dataField: 'accountEnabled',
      text: 'Account Status',
      formatter: enabledFormatter,
      sort: true,
      editable: false,
      headerStyle: (column, colIndex) => {
        return { width: '100px' }
      },
      csvFormatter: (cell, row, rowIndex) => csvAccountStatus[cell],
      filter: selectFilter({
        placeholder: 'Filter...',
        options: selectEnabledOptions,
        getFilter: (filter) => {
          enabledFilter = filter
        },
      }),
    },
    {
      dataField: 'mailboxType',
      text: 'Mailbox Type',
      formatter: mailboxTypeFormatter,
      sort: true,
      editable: false,
      headerStyle: (column, colIndex) => {
        return { width: '100px' }
      },
      csvFormatter: (cell, row, rowIndex) => csvMailboxType[cell],
      filter: selectFilter({
        placeholder: 'Filter Mailbox Type...',
        options: selectMailboxTypeOptions,
        getFilter: (filter) => {
          enabledFilter = filter
        },
      }),
    },
    {
      dataField: 'invoiceStatus',
      text: 'Invoice Status',
      sort: true,
      headerStyle: (column, colIndex) => {
        return { width: '150px' }
      },
      filter: selectFilter({
        options: selectFilterOptions,
      }),
      formatter: statusFormatter,
      csvFormatter: (cell, row, rowIndex) => csvInvoiceStatus[cell],
      editorRenderer: (editorProps, value, row, column, rowIndex, columnIndex) => {
        return (
          <DropDownEditor
            options={selectOptions}
            forceUpdate={forceUpdate}
            isClearable={false}
            isMulti={false}
            isStatus={true}
            {...editorProps}
            value={row.invoiceStatus}
            dateValue={row.ignoredUntil}
            showExclude={false}
          />
        )
      },
    },
    {
      dataField: 'additionExclusion',
      text: 'Addition Exclusions',
      sort: false,
      headerStyle: (column, colIndex) => {
        return { width: '200px' }
      },
      editable: (cell, row, rowIndex, colIndex) => {
        return !row.excludedFromAgreement;
      },
      // filter: selectFilter({
      //   placeholder: 'Filter...',
      //   options: excludedOptions,
      //   onFilter: filterByExclusionAddition,
      // }),
      formatter: exclusionFormatter,
      csvFormatter: additionExclusionCsvFormatter,
      editorRenderer: (editorProps, value, row, column, rowIndex, columnIndex) => {
        return (
          <DropDownEditor
            options={props.selectedCompanyExcludedAdditions}
            forceUpdate={forceUpdate}
            isClearable={false}
            isMulti={true}
            {...editorProps}
            isStatus={false}
            value={row.selectedExcludedAdditions}
            dateValue={row.ignoredUntil}
            excludedValue={row.excludedFromAgreement}
            showExclude={row}
          />
        )
      },
    },
    {
      dataField: 'excludedFromAgreement',
      text: 'Excluded',
      formatter: excludeAgreementFormatter,
      headerStyle: (column, colIndex) => {
        return { width: '90px' }
      },
      sort: true,
      filter: selectFilter({
        options: ExcludeAgreementFilterOptions,
      }),
      editable: true,
      editorRenderer: (editorProps, value, row, column, rowIndex, columnIndex) => {
          if (row.excludedFromAgreement) {

              return (
                  <ExcludedEditor
                      row={row}
                      forceUpdate={forceUpdate}
                      {...editorProps}
                  />
              )
          }
          else {
              handleExclusionEditClicked(row);
              return;
          }
      },
    },
  ]
  const columnsViewer = [
    {
      dataField: 'id',
      text: 'Id',
      hidden: true,
      editable: false,
      csvExport: false,
    },
    {
      dataField: 'displayName',
      text: 'Name',
      sort: true,
      headerStyle: (column, colIndex) => {
        return { width: '175px' }
      },
      filter: textFilter({
        placeholder: 'Filter Name...',
      }),
      formatter: textFieldFormatter,
      editable: false,
    },
    {
      dataField: 'userPrincipalName',
      text: 'UPN',
      formatter: textFieldFormatter,
      headerStyle: (column, colIndex) => {
        return { width: '275px' }
      },
      sort: true,
      filter: textFilter({
        placeholder: 'Filter Email...',
      }),
      editable: false,
    },
    {
      dataField: 'accountEnabled',
      text: 'Account Status',
      formatter: enabledFormatter,
      sort: true,
      editable: false,
      headerStyle: (column, colIndex) => {
        return { width: '100px' }
      },
      csvFormatter: (cell, row, rowIndex) => csvAccountStatus[cell],
      filter: selectFilter({
        placeholder: 'Filter...',
        options: selectEnabledOptions,
        getFilter: (filter) => {
          enabledFilter = filter
        },
      }),
    },
    {
      dataField: 'mailboxType',
      text: 'Mailbox Type',
      formatter: mailboxTypeFormatter,
      sort: true,
      editable: false,
      headerStyle: (column, colIndex) => {
        return { width: '100px' }
      },
      csvFormatter: (cell, row, rowIndex) => csvMailboxType[cell],
      filter: selectFilter({
        placeholder: 'Filter Mailbox Type...',
        options: selectMailboxTypeOptions,
        getFilter: (filter) => {
          enabledFilter = filter
        },
      }),
    },
    {
      dataField: 'invoiceStatus',
      text: 'Invoice Status',
      sort: true,
      headerStyle: (column, colIndex) => {
        return { width: '200px' }
      },
      filter: selectFilter({
        options: selectFilterOptions,
      }),
      formatter: statusFormatterNoEdit,
      csvFormatter: (cell, row, rowIndex) => csvInvoiceStatus[cell],
    },
    {
      dataField: 'additionExclusion',
      text: 'Addition Exclusions',
      sort: false,
      headerStyle: (column, colIndex) => {
        return { width: '200px' }
      },
      // filter: selectFilter({
      //   placeholder: 'Filter...',
      //   options: excludedOptions,
      //   onFilter: filterByExclusionAddition,
      // }),
      formatter: exclusionFormatterNoEdit,
      csvFormatter: additionExclusionCsvFormatter,
    },
    {
      dataField: 'excludedFromAgreement',
      text: 'Excluded',
      formatter: excludeAgreementFormatter,
      headerStyle: (column, colIndex) => {
        return { width: '90px' }
      },
      sort: true,
      filter: selectFilter({
        options: ExcludeAgreementFilterOptions,
      }),
      editable: false,
    },
  ]

  const cellEdit = {
    mode: 'click',
    blurToSave: false,
    errorMessage: errorMessage,
  }

  if (props.loading) {
    return <LoadingSpinner />
  } else if (props.displayedCompanyUsers) {
    return (
      <AzureAD provider={authProvider}>
        {({ accountInfo }) => {
          let isEditor = false
          if (accountInfo && accountInfo.account && accountInfo.account.idToken && accountInfo.account.idToken.roles) {
            // TODO: test is not editor
            if (accountInfo.account.idToken.roles.includes('Admin')) {
              isEditor = true
            } else if (accountInfo.account.idToken.roles.includes('Sales')) {
              isEditor = true
            } else if (accountInfo.account.idToken.roles.includes('ITManager')) {
              isEditor = true
            }
          }

          let selectedCompanyExcludedAdditions = props.selectedCompanyExcludedAdditions;

          return (
            <PaginationProvider
              pagination={paginationFactory({
                custom: true,
                totalSize: props.displayedCompanyUsersCount,
                page: props.page,
                sizePerPage: props.pageSize,
                sizePerPageList: [
                  { text: '10', value: 10 },
                  { text: '20', value: 20 },
                  { text: '50', value: 50 },
                  { text: '100', value: 100 },
                  { text: 'All', value: props.displayedCompanyUsersCount },
                ],
              })}
            >
              {({ paginationProps, paginationTableProps }) => (
                <ToolkitProvider
                  bootstrap4
                  keyField="id"
                  data={props.displayedCompanyUsers}
                  columns={isEditor ? columnsEditor : columnsViewer}
                  selectedCompany={props.selectedCompany}
                  exportCSV={{
                    fileName: `${props.selectedCompany && props.selectedCompany.companyName}.csv`,
                    onlyExportFiltered: true,
                    exportAll: false,
                  }}
                >
                  {(props) => {
                    return (
                      <div>
                        <Alert isOpen={!hasDismissed} color="info" toggle={handleDismissed}>
                          Export Users now only exports the visible users, change page size to All first to export all
                          Users.
                        </Alert>
                        <ExportCSVButton className="btn-outline-primary" {...props.csvProps}>
                          Export Users
                        </ExportCSVButton>{' '}
                        <PaginationListStandalone {...paginationProps} />
                        <SizePerPageDropdownStandalone
                          btnContextual="btn-outline-primary"
                          className="dropDownStyle"
                          {...paginationProps}
                        />
                        {isEditor ? (
                          <>
                            <Button
                              disabled={selectedRowCount === 0}
                              outline
                              color="primary"
                              onClick={() => handleBulkRowUpdateModalOpen(tableRef?.selectionContext.selected)} >
                              Update Users
                            </Button>

                            <BootstrapTable
                                bordered={false}
                                {...props.baseProps}
                                pagination={paginationFactory()}
                                filter={filterFactory()}
                                filterPosition="top"
                                loading={props.loading}
                                cellEdit={cellEditFactory(cellEdit)}
                                remote={{ cellEdit: true, pagination: true }}
                                onTableChange={handleTableChange}
                                selectRow={{
                                  mode: "checkbox",
                                  hideSelectColumn: false,
                                  hideSelectAll: true,
                                  clickToSelect: false,
                                  bgColor: '#0056b836',
                                  onSelect: (obj, newState) => {
                                    setSelectedRowCountCalcRequired(true);
                                  }
                                }}
                                ref={ n => {
                                  tableRef = n;
                                  if(tableRef !== null && tableRef !== undefined && selectedRowCountCalcRequired)
                                    calcSelectedRowCount();
                                  return tableRef;
                                }}
                                {...paginationTableProps} />

                              <Modal
                                isOpen={showUpdateRowsModal}
                                toggle={hideShowUpdateRowsModal}
                                backdrop={modalBackDrop}>
                                  <ModalHeader toggle={() => { if(!modalSaving){ hideShowUpdateRowsModal(); } }}>Bulk Update Users</ModalHeader>

                                  <ModalBody>
                                    <b>You have {modalSelectedUsers.length} users selected.</b>
                                    <FormGroup row className="mt-4 ms-4 me-4">
                                      <StyledLabel sm={4} for="modalInvoiceStatus">
                                        Invoice Status:
                                      </StyledLabel>
                                      <Col sm={8}>
                                        {/* <Input
                                          autoComplete="off"
                                          // invalid={errors.applicationSecret && touched.applicationSecret ? true : false}
                                          // value={values ? values.applicationSecret : ''}
                                          type="password"
                                          name="modalInvoiceStatus"
                                          id="modalInvoiceStatus"
                                          placeholder="Enter Application Secret"
                                          // onChange={handleChange}
                                          // onBlur={handleBlur}
                                        /> */}
                                        {/* <FormFeedback>{errors.applicationSecret}</FormFeedback> */}
                                        <DropDownEditor
                                          options={selectOptions}
                                          forceUpdate={forceUpdate}
                                          isClearable={true}
                                          isMulti={false}
                                          isStatus={true}
                                          value={modalOptions.invoiceStatus}
                                          dateValue={modalOptions.ignoredUntil}
                                          valueChanged={status => {
                                            modalOptions.invoiceStatus = status.value;
                                          }}
                                          ignoredChanged={date => {
                                            modalOptions.ignoredUntil = date;
                                          }}
                                          reasonChanged={reason => {
                                            modalOptions.invoiceReason = reason;
                                          }}
                                          showExclude={false}
                                          hideActions={true}
                                        />
                                      </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                      <StyledLabel sm={4} for="modaladditionExclusions">
                                        Addition Exclusions:
                                      </StyledLabel>
                                      <Col sm={8}>
                                        {/* <Input
                                          autoComplete="off"
                                          // invalid={errors.applicationSecret && touched.applicationSecret ? true : false}
                                          // value={values ? values.applicationSecret : ''}
                                          type="password"
                                          name="modaladditionExclusions"
                                          id="modaladditionExclusions"
                                          placeholder="Enter Application Secret"
                                          // onChange={handleChange}
                                          // onBlur={handleBlur}
                                        /> */}
                                        {/* <FormFeedback>{errors.applicationSecret}</FormFeedback> */}
                                        <DropDownEditor
                                          options={selectedCompanyExcludedAdditions}
                                          forceUpdate={forceUpdate}
                                          isClearable={true}
                                          isMulti={true}
                                          isStatus={false}
                                          value={modalOptions.selectedExcludedAdditions}
                                          dateValue={null}
                                          valueChanged={(selectedExcludedAdditions) => {
                                            modalOptions.selectedExcludedAdditions = selectedExcludedAdditions;
                                          }}
                                          reasonChanged={reason => {
                                            modalOptions.excludeReason = reason;
                                          }}
                                          excludedValue={null}
                                          showExclude={false}
                                          hideActions={true}
                                        />
                                      </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                      <StyledLabel sm={4} for="modalExcluded">
                                        Excluded:
                                      </StyledLabel>
                                      <Col sm={8}>
                                        <Input
                                          autoComplete="off"
                                          value={modalOptions.excluded}
                                          type="checkbox"
                                          name="modalExcluded"
                                          id="modalExcluded"
                                          onChange={(ev) => {
                                            modalOptions.excluded = ev.target.checked;
                                          }}
                                          style={{ marginLeft: "0px", marginTop: "7px" }}
                                        />
                                        {/* <FormFeedback>{errors.applicationSecret}</FormFeedback> */}
                                      </Col>
                                    </FormGroup>

                                    {(
                                      modalSaving ? (
                                        <Progress
                                          animated
                                          value={modalProgress}
                                        />
                                      ) : (
                                        null
                                      )
                                    )}

                                  </ModalBody>

                                  <ModalFooter>
                                    <Button color="secondary" onClick={hideShowUpdateRowsModal} disabled={modalSaving}>
                                      Cancel
                                    </Button>
                                    <Button color="primary" onClick={() => handleBulkRowUpdateModalSubmit(modalSelectedUsers)} disabled={modalSaving}>
                                      Update
                                    </Button>
                                  </ModalFooter>
                              </Modal>

                              <Modal
                                isOpen={showExclusionUpdateModal}
                                toggle={hideShowExclusionUpdateModal}
                                backdrop={modalBackDrop}>
                                <ModalHeader toggle={() => { if (!modalSaving) { hideShowExclusionUpdateModal(); } }}> {
                                            modalSelectedUsers.excludedFromAgreement ? "Including " : "Excluding "} {modalSelectedUsers.displayName}
                                </ModalHeader>

                                <ModalBody>
                                            <b>You are <u>{modalSelectedUsers.excludedFromAgreement ? "including" : "excluding"}</u> {modalSelectedUsers.displayName} {modalSelectedUsers.excludedFromAgreement ? "to" : "from"} the agreement.</b>
                                    {!modalSelectedUsers.excludedFromAgreement && (
                                        <FormGroup row>
                                            <Col sm={12}>
                                                <Input
                                                    id="reasonId"
                                                    autoComplete="off"
                                                    type="textarea"
                                                    value={excludeModalReason}
                                                    onChange={(ev) => {
                                                        modalOptions.excludeReason = ev.target.value;
                                                        setExcludeModalReason(modalOptions.excludeReason);
                                                    }}        
                                                    style={{ marginTop: '5px', marginBottom: '5px' }}
                                                    placeholder="Reason for Change*"
                                                />
                                                {(!modalSelectedUsers.excludedFromAgreement && (modalOptions.excludeReason == null || modalOptions.excludeReason.length <= 0)) && (
                                                    <span>Please specify a reason for exclusion</span>
                                                )}
                                            </Col>
                                        </FormGroup>
                                    )}
                                    {(
                                        modalSaving ? (
                                            <Progress
                                                animated
                                                value={modalProgress}
                                            />
                                        ) : (
                                            null
                                        )
                                    )}
                                </ModalBody>

                                <ModalFooter>
                                    <Button color="secondary" onClick={hideShowExclusionUpdateModal} disabled={modalSaving}>
                                        Cancel
                                            </Button>
                                            <Button color="primary" onClick={() => handleExcludeModalSubmit(modalOptions)} disabled={modalSaving || (!modalSelectedUsers.excludedFromAgreement && (modalOptions.excludeReason == null || modalOptions.excludeReason.length <= 0))}>
                                        Confirm
                                    </Button>
                                </ModalFooter>
                              </Modal>
                            </>
                        ) : (
                          <BootstrapTable
                            bordered={false}
                            {...props.baseProps}
                            pagination={paginationFactory()}
                            filter={filterFactory()}
                            filterPosition="top"
                            loading={props.loading}
                            remote={{ cellEdit: false, pagination: true }}
                            onTableChange={handleTableChange}
                            {...paginationTableProps}
                          />
                        )}
                      </div>
                    )
                  }}
                </ToolkitProvider>
              )}
            </PaginationProvider>
          )
        }}
      </AzureAD>
    )
  } else {
    return <div>No Users Found</div>
  }
}

const mapStateToProps = (state) => ({
  loading: state.company.loading,
  selectedCompany: state.company.selectedCompany,
  displayedCompanyUsers: state.company.displayedCompanyUsers,
  displayedCompanyUsersCount: state.company.displayedCompanyUsersCount,
  selectedCompanyExcludedAdditions: state.company.selectedCompanyExcludedAdditions,
})

const mapDispatchToProps = {
  handleUpdateAccountStatus,
  handleExcludeAccountStatus,
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyUsersTable)